import { connect } from 'react-redux';
import { useContext } from 'react';

import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { getAccountProsecutorOrganizationsWithDistrictSelectOptions } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

interface IAgreementsProsecutorOrganizationProps {
  id: string;
  isWatchOnly: boolean;
  name: string;
}

interface IAgreementsProsecutorOrganizationStoreProps {
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
}

const AgreementsProsecutorOrganizationWithoutStore = ({
  id,
  isWatchOnly,
  name,
  userProsecutorOrganisationsSelectOptions,
}: IAgreementsProsecutorOrganizationProps & IAgreementsProsecutorOrganizationStoreProps) => {
  const { isKnm, isPm, isDecision } = useContext(AgreementsContext);

  return (
    <Row>
      <FieldBlock
        id={`${id}.prosecutorOrganization`}
        label={getTitleFieldWithRedStar({
          label: 'Наименование прокуратуры',
          field: `${name}.prosecutorOrganization`,
          isKnm,
          isPm,
          isDecision,
        })}
      >
        <SelectInputField
          name={`${name}.prosecutorOrganization`}
          options={userProsecutorOrganisationsSelectOptions}
          size="medium"
          disabled={isWatchOnly}
        />
      </FieldBlock>
    </Row>
  );
};

const mapStateToProps = (state: IRootState): IAgreementsProsecutorOrganizationStoreProps => ({
  userProsecutorOrganisationsSelectOptions: getAccountProsecutorOrganizationsWithDistrictSelectOptions(state),
});

export const AgreementsProsecutorOrganization = connect(mapStateToProps)(AgreementsProsecutorOrganizationWithoutStore);
